<template>
  <div class="realize_wrap">
    <div class="realize_img">
      <div class="img_tit">青山银山不如绿水青山</div>
    </div>
    <div class="realize_nav_wrap">
      <el-row class="realize_nav" type="flex" justify="center">
        <el-col
          v-for="(tab, index) in tabList"
          :key="index"
          class="realize_item"
          :class="tabSelectIndex === index ? 'active' : ''"
          :span="2"
          :xs="6"
          @click.native="changeTabIndex(index)"
        >
          <div class="nav_top">
            <div>{{ tab.tit }}</div>
            <div class="nav_en">{{ tab.en }}</div>
          </div>
          <div
            class="nav_bottom"
            :style="tabSelectIndex === index ? '' : 'background:#fff'"
          ></div>
        </el-col>
      </el-row>
    </div>
    <div class="show_box_index" v-if="tabSelectIndex === 0">
      <div class="product_shows_wrap">
        <div class="production_title_wrap">
          <div class="production_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="production_title">公司介绍</div>
              <div style="font-size: 18px">About Us</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="table_wrap hidden-xs-only">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氢能装备制造业创新中心以“公司+联盟”形式联合打造，由政府、企业、高校、科研机构等主体联动共建，聚焦氢能装备领域，以氢能制取、氢能储运、氢能应用相关技术为主攻方向，打通“行业技术攻关——中试——转移转化——工艺优化——首次商业化”创新链条各环节，提供氢能产业创新的公共服务，积极开展国际交流与人才培养合作，打造跨界协同的创新生态系统，以高水平的装备创新推进氢能开发利用，促进氢能产业高质量发展
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;下一步将借助氢能装备制造业创新中心入围全省培育建设名单契机，全力推动氢能未来产业先导区建设，积极参与浙江省“环杭州湾”氢走廊建设，加强长三角区域氢燃料电池汽车示范应用领域合作，进一步助力科技创新和产业创新深度融合发展
          </p>
        </div>
        <div class="table_wrap hidden-xs-only en">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hydrogen Energy Equipment
            Manufacturing Innovation Center The Hydrogen Energy Equipment
            Manufacturing Innovation Center is jointly established through a
            "Company + Alliance" model, bringing together governments,
            enterprises, universities, and research institutions to co-build an
            ecosystem. The center focuses on the hydrogen energy equipment
            sector, with core research directions in hydrogen energy production,
            hydrogen storage and transportation, and hydrogen energy
            applications. We aim to establish a complete innovation chain
            spanning from industry technology breakthroughs, pilot-scale
            testing, technology transfer and commercialization, process
            optimization, to initial commercial deployment. The center provides
            comprehensive public services for hydrogen energy industry
            innovation, actively facilitates international exchanges and talent
            cultivation cooperation, and builds a cross-sector collaborative
            innovation ecosystem. Through high-level equipment innovation, we
            promote hydrogen energy development and utilization, and advance
            high-quality development of the hydrogen energy industry.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Future Outlook Moving
            forward, we will leverage the opportunity of being selected for the
            provincial cultivation and construction list to fully advance the
            development of the hydrogen energy future industry pilot zone. We
            will actively participate in Zhejiang Province's "Greater Bay Area
            around Hangzhou" hydrogen corridor construction, strengthen
            cooperation with the Yangtze River Delta region in hydrogen fuel
            cell vehicle demonstration applications, and further facilitate the
            deep integration of scientific innovation and industrial innovation
            development.
          </p>
        </div>
        <div class="table_wrap_mobile hidden-sm-and-up">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氢能装备制造业创新中心以“公司+联盟”形式联合打造，由政府、企业、高校、科研机构等主体联动共建，聚焦氢能装备领域，以氢能制取、氢能储运、氢能应用相关技术为主攻方向，打通“行业技术攻关——中试——转移转化——工艺优化——首次商业化”创新链条各环节，提供氢能产业创新的公共服务，积极开展国际交流与人才培养合作，打造跨界协同的创新生态系统，以高水平的装备创新推进氢能开发利用，促进氢能产业高质量发展
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;下一步将借助氢能装备制造业创新中心入围全省培育建设名单契机，全力推动氢能未来产业先导区建设，积极参与浙江省“环杭州湾”氢走廊建设，加强长三角区域氢燃料电池汽车示范应用领域合作，进一步助力科技创新和产业创新深度融合发展
          </p>
        </div>
        <div class="table_wrap_mobile hidden-sm-and-up">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hydrogen Energy Equipment
            Manufacturing Innovation Center The Hydrogen Energy Equipment
            Manufacturing Innovation Center is jointly established through a
            "Company + Alliance" model, bringing together governments,
            enterprises, universities, and research institutions to co-build an
            ecosystem. The center focuses on the hydrogen energy equipment
            sector, with core research directions in hydrogen energy production,
            hydrogen storage and transportation, and hydrogen energy
            applications. We aim to establish a complete innovation chain
            spanning from industry technology breakthroughs, pilot-scale
            testing, technology transfer and commercialization, process
            optimization, to initial commercial deployment. The center provides
            comprehensive public services for hydrogen energy industry
            innovation, actively facilitates international exchanges and talent
            cultivation cooperation, and builds a cross-sector collaborative
            innovation ecosystem. Through high-level equipment innovation, we
            promote hydrogen energy development and utilization, and advance
            high-quality development of the hydrogen energy industry.
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Future Outlook Moving
            forward, we will leverage the opportunity of being selected for the
            provincial cultivation and construction list to fully advance the
            development of the hydrogen energy future industry pilot zone. We
            will actively participate in Zhejiang Province's "Greater Bay Area
            around Hangzhou" hydrogen corridor construction, strengthen
            cooperation with the Yangtze River Delta region in hydrogen fuel
            cell vehicle demonstration applications, and further facilitate the
            deep integration of scientific innovation and industrial innovation
            development.
          </p>
        </div>
      </div>
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="production_title">我们的优势</div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="advantage_out_wrap">
        <el-row class="advantage_wrap">
          <el-col
            class="advantage_item"
            v-for="(item, index) in advantageList"
            :key="index"
            :span="7"
            :xs="11"
          >
            <div class="item_top">
              <div class="icon hidden-xs-only"><i :class="item.icon"></i></div>
              <div class="tit">{{ item.title }}</div>
            </div>
            <ul
              class="item_desc"
              v-for="(desc, index2) in item.desc"
              :key="index2"
            >
              <li>{{ desc }}</li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="production_title">公司合作伙伴</div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <PersonCard />
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center" style="width: 50%">
            <div class="production_title">国际合作与人才交流</div>
            <div class="production_desc"></div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <International />
    </div>
    <div class="show_box_index" v-if="tabSelectIndex === 1">
      <div class="four_wrap">
        <el-row type="flex" justify="center" class="out_card" :gutter="10">
          <el-col
            :span="7"
            v-for="(item, index) in contactMsg"
            :key="index"
            class="card_item"
          >
            <el-card :body-style="{ padding: '0px' }" class="card_content">
              <div style="padding: 14px">
                <img :src="item.icon" class="image" />
                <div class="title" style="margin-top: 20px; font-weight: bold">
                  <p>{{ item.tit }}</p>
                  <p>{{ item.en }}</p>
                </div>
                <div class="bottom clearfix" v-if="item.desc">
                  <p type="text" class="button">{{ item.desc }}</p>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="production_title">位置</div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="four_card_spa">
        <div id="map"></div>
      </div>
    </div>
    <div class="show_box_index" v-if="tabSelectIndex === 2">
      <div class="concat-warp">
        <div class="concat">
          <el-form ref="form" :model="form" :rules="rules">
            <el-row :gutter="24">
              <el-col :span="11" :xs="24">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" :xs="24">
                <el-form-item label="公司" prop="company">
                  <el-input v-model="form.company"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="11" :xs="24">
                <el-form-item label="电话" prop="phone">
                  <el-input v-model="form.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" :xs="24">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="form.email"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22" :xs="24">
                <el-form-item label="留言">
                  <el-input
                    type="textarea"
                    v-model="form.message"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <el-form-item style="text-align: center">
                  <el-button type="primary" @click="submitForm('form')"
                    >立即发送</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme></MobileCallme>
  </div>
</template>

<script>
import PersonCard from "./PersonCard.vue";
import International from "./International.vue";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
import ReailzeCard from "./ReailzeCard.vue";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  data() {
    return {
      form: {
        name: "",
        company: "",
        phone: "",
        email: "",
        message: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司", trigger: "blur" }],
        phone: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          { validator: this.validatePhone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        message: [{ required: true, message: "请输入留言", trigger: "blur" }],
      },
      tabList: [
        {
          tit: "公司介绍",
        },
        {
          tit: "联系公司",
          en: "Contact Us",
        },
        {
          tit: "联系我们",
        },
      ],
      tabSelectIndex: 0,
      advantageList: [
        {
          icon: "",
          title: "团队能力",
          desc: ["技术驱动型队伍", "打造行业领先的氢能产业科技链"],
        },
        {
          icon: "",
          title: "市场优势",
          desc: ["自研创新工厂", "氢能技术研发的实践者"],
        },
        {
          icon: "",
          title: "数据优势",
          desc: ["关键材料相关数据", "生产工艺核心流程"],
        },
        {
          icon: "",
          title: "技术优势",
          desc: ["“公司+联盟+专家委员会”", "高校+科研机构"],
        },
        {
          icon: "",
          title: "行业影响力",
          desc: ["技术驱动型队伍", "国务院/浙江人民政府/清华大学"],
        },
        {
          icon: "",
          title: "政策影响力",
          desc: ["氢能产业大脑", "制造强国战略/“双碳”工作重大要求“"],
        },
      ],
      contactMsg: [
        {
          tit: "市场合作",
          en: "Partnership Opportunities",
          desc: "暂未开放",
          icon: require("../../assets/img/61.png"),
        },
        {
          tit: "咨询电话",
          en: "Tel",
          desc: "86 15730072804",
          icon: require("../../assets/img/60.png"),
        },
        {
          tit: "咨询邮箱",
          en: "Mail",
          desc: "liumengyuan@heeic.com",
          icon: require("../../assets/img/61.png"),
        },
      ],
    };
  },
  components: {
    PersonCard,
    International,
    CallMe,
    MobileCallme,
    ReailzeCard,
  },
  created() {
    this.tabSelectIndex =
      this.$route.path.substr(this.$route.path.length - 1) * 1 - 1;
    if (this.tabSelectIndex == 1) {
      this.initMap();
    }
  },
  watch: {
    $route() {
      this.tabSelectIndex =
        this.$route.path.substr(this.$route.path.length - 1) * 1 - 1;
      if (this.tabSelectIndex == 1) {
        this.initMap();
      }
    },
  },
  methods: {
    validatePhone(rule, value, callback) {
      const phoneRegex = /^(1[3-9])\d{9}$/;
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else if (!phoneRegex.test(value)) {
        return callback(new Error("手机号格式不正确"));
      }
      callback();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changeTabIndex(index) {
      this.tabSelectIndex = index;
      if (index == 1) {
        this.initMap();
      }
    },
    initMap() {
      AMapLoader.load({
        key: "55741503ded0bc56e20046714161fdfe", // 替换为你的高德地图API密钥
        version: "2.0", // API版本号，默认为2.0
        plugins: ["AMap.Geolocation", "AMap.PlaceSearch"], // 需要使用的插件列表，此处示例使用了位置搜索插件和定位插件
      })
        .then((AMap) => {
          var map = new AMap.Map("map", {
            resizeEnable: true,
            center: [121.104421, 30.610933], // 初始化地图的中心点坐标，此处为北京天安门的位置
            zoom: 18, // 初始化地图的缩放级别
          });

          // 添加标记点
          var marker = new AMap.Marker({
            position: new AMap.LngLat(121.104421, 30.610933), // 标记点的经纬度坐标
            map: map, // 将标记添加到地图对象中
            title: "浙江省嘉兴市港区中山东路188号1幢701内710室", // 标记点的标题
          });
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  margin-top: 0px;
}
.concat-warp {
  padding-top: 30px;
  display: flex;
  justify-content: center;
  background: url("../../assets/img/bottom_bg.90c1ea1.jpg") 0 0 no-repeat;
  background-size: cover;
  .concat {
    width: 70%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
  }
}
.realize_wrap {
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/img/aboutbg.054cc8b.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .realize_nav_wrap {
    width: 100%;
    height: 60px;
    @media screen and (max-width: 768px) {
      height: 50px;
    }
    .realize_nav {
      height: 100%;
      display: flex;
      align-items: center;
      .active {
        font-weight: bold;
        color: #000;
      }
      .realize_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .nav_top {
          text-align: center;
          font-size: 18px;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
          .nav_en {
            font-size: 12px;
            @media screen and (max-width: 768px) {
              font-size: 10px;
            }
          }
        }
        .nav_bottom {
          width: 30%;
          height: 4px;
          margin-top: 10px;
          background: #2091d3;
        }
      }
    }
  }
  .product_shows_wrap {
    width: 100%;
    padding: 10px 0 50px 0;
    background: #f4f9fc;
    margin-top: -7px;
    box-sizing: border-box;
    height: 900px;
    position: relative;
    @media screen and (max-width: 768px) {
      background: #f4f9fc;
      height: auto;
    }
    .table_wrap {
      margin-left: 15%;
      width: 70%;
      padding: 20px 0;
      line-height: 1.8;
      color: #576671;
      font-weight: 400;
      font-size: 20px;
    }
    .table_wrap_mobile {
      padding: 1rem;
      p {
        font-size: 0.9rem;
      }
      .table_form {
        .table_form_item {
          font-weight: bold;
          margin-top: 1rem;
          font-size: 0.85rem;
          span {
            color: #000;
            font-size: 0.9rem;
            padding-right: 30px;
          }
        }
      }
    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    .advantage_wrap {
      width: 70%;
      display: flex;
      margin-top: 70px;
      justify-content: center;
      flex-wrap: wrap;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      .advantage_item {
        height: auto;
        padding: 30px 20px 60px 20px;
        margin-right: 10px;
        &:nth-child(1) {
          background: url("../../assets/img/newEdition/31.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }
        &:nth-child(2) {
          background: url("../../assets/img/newEdition/32.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }
        &:nth-child(3) {
          background: url("../../assets/img/newEdition/32.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }
        &:nth-child(4) {
          background: url("../../assets/img/newEdition/33.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }
        &:nth-child(5) {
          background: url("../../assets/img/newEdition/34.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }
        &:nth-child(6) {
          background: url("../../assets/img/newEdition/35.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }
        margin: 15px;
        box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);
        @media screen and (max-width: 768px) {
          margin: 0;
          padding: 0 15px;
          margin-top: 3px;
          height: 140px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          height: 200px;
        }
        .item_top {
          display: flex;
          align-items: center;
          @media screen and (max-width: 768px) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          }
          .icon {
            i {
              color: #2091d3;
              font-size: 26px;
              padding-right: 10px;
              @media screen and (max-width: 768px) {
                font-size: 2rem;
                margin-bottom: 10px;
              }
            }
          }
          .tit {
            width: 100%;
            color: #1c1c1c;
            font-size: 28px;
            font-weight: bold;
            @media screen and (max-width: 768px) {
              font-size: 1rem;
              text-align: left;
            }
          }
        }
        .item_desc {
          font-size: 20px;
          line-height: 20px;
          margin: 0;
          padding: 0;
          margin-top: 20px;
          color: #646464;
          list-style: none;
          li {
            line-height: 2rem;
            @media screen and (max-width: 768px) {
              line-height: 1rem;
              font-size: 12px;
            }
            &:first-child {
              margin-top: 30px;
            }
          }
        }
      }
    }
  }
  .china_map {
    width: 70%;
    margin: 50px auto;
    img {
      width: 100%;
    }
  }
  .timeline_wrap {
    width: 70%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .timeline_card {
      h4 {
        font-size: 24px;
        @media screen and (max-width: 768px) {
          font-size: 18px;
        }
      }
      .timeline_time {
        font-size: 12px;
      }
      img {
        width: 30%;
        margin-top: 20px;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
      }
    }
  }
  .three_box {
    width: 70%;
    margin: 0 auto;
    height: 200px;
    text-align: center;
    background: url("../../assets/img/ryzz.bc140e4.jpg") 0 0 no-repeat;
    background-size: cover;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    h1 {
      font-size: 40px;
      line-height: 200px;
      color: #fff;
    }
  }
  .three_box_card {
    width: 70%;
    margin: 30px auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .out_card {
      flex-wrap: wrap;
      .card_item {
        @media screen and (max-width: 768px) {
          margin-top: 10px;
        }
        &:nth-child(n + 4) {
          margin-top: 10px;
        }
        img {
          padding-top: 30px;
          width: 100%;
        }
      }
    }
  }
  .four_wrap {
    width: 70%;
    margin: 0 auto;
    background: url("../../assets/img/58.e28b1c0.png") 0 0 no-repeat;
    background-size: cover;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 150px;
    }
    .out_card {
      width: 100%;
      flex-wrap: wrap;
      .card_item {
        &:nth-child(n + 4) {
          margin-top: 10px;
        }
        .card_content {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 100%;
          img {
            padding-top: 30px;
            width: 30% !important;
            height: 110px !important;
            @media screen and (max-width: 768px) {
              width: 50%;
            }
          }
          .title {
            font-size: 20px;
          }
          .button {
            font-size: 16px;
            padding: 3px 0;
            color: #0b57d0;
          }
        }
      }
    }
  }
  .four_card_spa {
    width: 70%;
    margin: 30px auto;
    @media screen and (max-width: 768px) {
      width: 90%;
      height: 200px;
    }
    #map {
      width: 100%;
      height: 500px;
      @media screen and (max-width: 768px) {
        width: 100%;
        height: 200px;
      }
    }
    .out_card {
      .card_item {
        h1 {
          font-size: 30px;
          margin-top: 10px;
        }
        img {
          margin-top: 30px;
          width: 5%;
        }
        p {
          font-size: 12px;
          margin-top: 10px;
        }
        .card_bg {
          width: 30px;
          height: 5px;
          background: #13519f;
        }
      }
    }
  }
}
.production_title_wrap {
  width: 100%;
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }
  .production_inner {
    display: flex;
    justify-content: center;
    .inner_left {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30% !important;
      }
    }
    .inner_center {
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 50px;
      @media screen and (max-width: 768px) {
        flex: 2.2;
      }
      .production_title {
        font-size: 40px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
      .production_desc {
        font-size: 16px;
        color: #787878;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
    .inner_right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30% !important;
      }
    }
  }
}
</style>